import gql from "graphql-tag"

import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

import fullSavedCard from "../fragments/fullSavedCard"

const paymentConfigsQuery = gql`
  query PaymentConfigs($platform: Platform!) {
    paymentConfigs(platform: $platform) {
      provider {
        name
        pubKey
      }
      paymentMethods {
        circuits
        extId
        kind
        returnUrl
        savedCards {
          ...fullSavedCard
        }
      }
    }
  }
  
  ${fullSavedCard}
`

export const paymentConfigsQueryKey = getQueryNames(paymentConfigsQuery)[0]

export default paymentConfigsQuery
